<template>
  <v-sheet class="about-section">
    <v-container>
      <TitleWidget>Sobre nós</TitleWidget>
      <v-row class="mt-4 flex-column-reverse flex-md-row">
        <v-col cols="12" lg="6"
          ><div
            class="
              ck-content
              text-center text-sm-left
              grey--text
              text-body-2 text-sm-body-1
            "
            v-html="item.text"
          ></div
        ></v-col>
        <v-col cols="12" lg="5">
          <div class="px-8">
            <img
              class="d-block"
              width="100%"
              :src="files + item.img"
              alt="Sobre"
            />
          </div>
        </v-col>
      </v-row> </v-container
  ></v-sheet>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
const _config = {
  mod: "about",
};
export default {
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: { TitleWidget },
};
</script>

<style lang="scss" scoped>
.about-section {
  padding-top: 80px;
  padding-bottom: 86px;
  @media (max-width: 960px) {
    padding-top: 40px;
    padding-bottom: 43px;
  }
}
</style>
